<script setup lang="ts">
import SpeakerInformation from './SpeakerInformation/SpeakerInformation.vue';
import { type FragmentType, graphql } from '~/gql';

const props = defineProps<{ speakers: FragmentType<typeof Speaker>[] }>();

const Speaker = graphql(`
  fragment SeminarDetailSpeakersSectionSpeaker on Speaker {
    id
    ...SeminarDetailTemplateSpeakerInformationSpeaker
  }
`);

const speakers = useComputedFragment(Speaker, () => props.speakers);
</script>

<template>
  <div :class="$style.section">
    <h2 :class="$style.section__heading">講師プロフィール</h2>
    <div :class="$style.section__speakers">
      <SpeakerInformation v-for="s in speakers" :key="s.id" :speaker="s" />
    </div>
  </div>
</template>

<style module lang="scss">
.section {
  &__heading {
    font-size: 20px;
    line-height: 1.8;
    font-weight: bold;
    text-align: center;
  }
  &__speakers {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 24px;
  }
}
</style>
